import React, { useEffect } from 'react'
import cn from '@ui/utils/cn'
import { badgeColor } from './styles'
import { ButtonBadge as BadgeType } from './types'
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'

const ButtonBadgeComponent = ({ badge }: { badge: BadgeType }) => {
  const animation = useSharedValue(0)

  useEffect(() => {
    animation.set(
      withRepeat(
        withTiming(1, {
          duration: 1500,
          easing: Easing.linear,
        }),
        -1,
        false
      )
    )
  }, [])

  const styleFade = useAnimatedStyle(() => {
    return {
      opacity: interpolate(animation.value, [0, 0.8, 1], [0.7, 0, 0]),
      transform: [{ scale: interpolate(animation.value, [0, 1], [1, 3]) }],
    }
  })

  const stylePulse = useAnimatedStyle(() => {
    return {
      transform: [
        { scale: interpolate(animation.value, [0, 0.5, 1], [1, 1.2, 1]) },
      ],
    }
  })

  return (
    <>
      <Animated.View
        style={styleFade}
        className={cn(
          'absolute -right-0.5 -top-0.5 h-2.5 w-2.5  rounded-full',
          badgeColor[badge]
        )}
      />
      <Animated.View
        style={stylePulse}
        className={cn(
          'absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full',
          badgeColor[badge]
        )}
      />
    </>
  )
}

export default ButtonBadgeComponent
